import React from 'react';
import { ProGallery } from 'pro-gallery';
import { ProGalleryInfoItem, ProGalleryLoadMore } from './index';
import { Spinner } from 'wix-ui-tpa/Spinner';
import { useSelector } from 'react-redux';

// Actions
import {
  getCurrentSettings,
  getGalleryMargin,
  getCurrentIdxForEndlessScroll,
} from '../../../../actions/gallery/gallerySettings';

let counter = 0;

const ProGalleryInstagram = ({
  eventsListener,
  items,
  mediaLinksMap,
  galleryHeight,
  heightShowMoreNeedToRemove,
  isLoadingItems,
  isMobile,
  type,
  loadingHeight,
  moreOptions = {},
  paddingGallery,
}) => {
  let options = getCurrentSettings(type);
  counter++;

  const padding = getGalleryMargin(options);
  options = { ...options, ...moreOptions };
  galleryHeight = galleryHeight - 2 * padding;
  let newHeight = heightShowMoreNeedToRemove
    ? galleryHeight - heightShowMoreNeedToRemove
    : galleryHeight;

  newHeight = newHeight < 0 ? 0 : newHeight;
  if (isLoadingItems) {
    return (
      <div style={{ height: loadingHeight, position: 'relative' }}>
        <Spinner diameter={isMobile ? 25 : 50} isCentered />
      </div>
    );
  }
  return (
    <div style={{ height: newHeight, padding }}>
      <ProGallery
        domId={'instagram-pro-gallery' + counter}
        items={items}
        options={options}
        // totalItemsCount={items.length}
        container={{
          scrollBase: 0,
          width: window.innerWidth - 2 * padding,
          height: galleryHeight,
        }}
        scrollingElement={window}
        eventsListener={(eName, eData) => eventsListener(eName, eData, type)}
        customHoverRenderer={(itemProps) => (
          <ProGalleryInfoItem
            type={type}
            mediaLinksMap={mediaLinksMap}
            item={
              items[itemProps.idx]?.originalData ||
              items[getCurrentIdxForEndlessScroll(itemProps.idx, items.length)]
                ?.originalData ||
              null
            }
          />
        )}
        customLoadMoreRenderer={(galleryProps) => (
          <ProGalleryLoadMore type={type} galleryProps={galleryProps} />
        )}
      />
    </div>
  );
};

export default ProGalleryInstagram;
